import { createRoute } from 'framework/routing';
import { WORKFORCE_ANALYTICS_PATH } from 'domain/people/workforceAnalytics/constants';

export const useWorkforceAnalyticsRoute = () => {
  return createRoute({ listRoute: WORKFORCE_ANALYTICS_PATH });
};
